import axios from "fetch-api/fetch-api";
import { IGenericRes } from "../interfaces/base-response";

export function updatePreferredLanguageApi(localeString: string) {
  return axios.post<IGenericRes>("/update-preferred-language", {
    language: localeString,
  });
}
